import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import cn from 'classnames'
import { useTheme } from '@mui/material/styles'

import { FormattedMessage, useIntl } from 'react-intl'
import { THEME_NAMES } from '@gymondo/frontend-core/themes'
import LanguageSwitch from '../page-footer/component/language-switch/language-switch'

import style from './signup-footer.module.scss'

const TRANSLATION_KEY = 'signup.footer.'

export const SignupFooter = ({ className, hasFloatingCta }) => {
    const theme = useTheme()
    const intl = useIntl()

    return (
        <footer
            className={cn(
                style.signupFooter,
                hasFloatingCta && style.hasFloatingCta,
                className
            )}
        >
            <div className={style.footerWrapper}>
                <div>
                    {theme.name !== THEME_NAMES.BUDDYFIT && (
                        <LanguageSwitch
                            className={style.languageSwitch}
                            isSignup
                        />
                    )}
                    <div className={style.footerText}>
                        {theme.name === THEME_NAMES.BUDDYFIT ? (
                            <>
                                <FormattedMessage
                                    id={`${TRANSLATION_KEY}part1`}
                                />

                                <a
                                    className="link"
                                    href="https://www.buddyfit.club/es/terms"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    <FormattedMessage
                                        id={`${TRANSLATION_KEY}terms`}
                                    />
                                </a>

                                <FormattedMessage
                                    id={`${TRANSLATION_KEY}part2`}
                                />

                                <a
                                    className="link"
                                    href="https://www.buddyfit.club/es/privacy"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    <FormattedMessage
                                        id={`${TRANSLATION_KEY}privacy`}
                                    />
                                </a>
                            </>
                        ) : (
                            <>
                                <FormattedMessage
                                    id={`${TRANSLATION_KEY}part1`}
                                />
                                <a
                                    href={intl.formatMessage({
                                        id: 'footer.terms.link',
                                    })}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="link"
                                >
                                    <FormattedMessage id="footer.terms" />
                                </a>

                                <FormattedMessage
                                    id={`${TRANSLATION_KEY}part2`}
                                />
                                <a
                                    href={intl.formatMessage({
                                        id: 'footer.privacy.link',
                                    })}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="link"
                                >
                                    <FormattedMessage id="footer.privacy" />
                                </a>

                                <FormattedMessage
                                    id={`${TRANSLATION_KEY}part3`}
                                />
                                <a
                                    href={intl.formatMessage({
                                        id: 'footer.imprint.link',
                                    })}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="link"
                                >
                                    <FormattedMessage id="footer.imprint" />
                                </a>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </footer>
    )
}

SignupFooter.propTypes = {
    className: PropTypes.string,
    hasFloatingCta: PropTypes.bool.isRequired,
}

SignupFooter.defaultProps = {
    className: '',
}

export const mapStateToProps = ({ layout }) => ({
    hasFloatingCta: layout.hasFloatingCta,
})

export default connect(mapStateToProps)(SignupFooter)
